// extracted by mini-css-extract-plugin
module.exports = {"checkBox":"CheckboxFreeBook_checkBox__1EXjE","checkBox__btn":"CheckboxFreeBook_checkBox__btn__VuN_D","checkBox__btn_active":"CheckboxFreeBook_checkBox__btn_active__5uyA_"};